import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Loader from '../components/Loader';
import { getAllBillsApi, getAllUsersApi, exportBillsApi } from '../utils/api';
import { formatDate } from '../utils/helper';
import { fields, LOCAL_STORAGE_KEY } from '../constants';
import config from '../config/env';
const BASE_URL = config['API_BASE_URL'];
const Bills = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

  const accessStates = (isLoggedIn && isLoggedIn.accessState) || [];
  const memberStates = fields.allState.filter((state) =>
    accessStates.includes(state.name)
  );

 const [filter, setFilter] = useState({
  state: '',
  from: '',
  to: '',
  createdBy: '',   // ✅ ADD THIS LINE
});

  const [initialLoading, setInitialLoading] = useState(true);
  const [bills, setBills] = useState([]);
  const [query, setQuery] = useState('');
  const [totalBillAmount, setTotalBillAmount] = useState('');
  const [users, setUsers] = useState([]);
  const [exporting, setExporting] = useState(false);

  const onChangeHandler = async (e) => {
    const x = { ...filter, [e.target.name]: e.target.value };
    setFilter((old) => ({ ...old, [e.target.name]: e.target.value }));
    const searchParams = new URLSearchParams();

    Object.keys(x).forEach((key) => {
      if (x[key]) {
        searchParams.set(key, x[key]);
      }
    });
    setQuery(searchParams.toString());
  };

  const onSearchHandler = async () => {
    setInitialLoading(true);
    await loadData(query);
  };

  const onResetHandler = async () => {
   setFilter({
    state: '',
    from: '',
    to: '',
    createdBy: '',   // ✅ ADD THIS LINE
  });


    setInitialLoading(true);
    const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    loadData(`createdBy=${isLoggedIn._id}`);
  };


  const loadData = async (params) => {
    const { data, error } = await getAllBillsApi(params);
    setInitialLoading(false);
    if (data.success) {
      let amount = 0;
      data.bills.forEach((e) => {
        amount += +e.totalAmount;
      });
      setTotalBillAmount(amount);
      console.log(data.bills);
      setBills(data.bills);
    } else {
    }
  };

  const loadAllUsers = async () => {
    const { data, error } = await getAllUsersApi();
    if (data) {
      setUsers(data.users);
    } else {
      alert(error.message);
    }
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      const { data, error } = await exportBillsApi(query);
      if (error) {
        alert(error.message || "Failed to export receipts");
        setExporting(false);
        return;
      }

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      
      const date = new Date();
      const pad = (n) => n.toString().padStart(2, '0');
      const yyyy = date.getFullYear();
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      const formattedTimestamp = `${yyyy}${mm}${dd}_${hh}${min}${ss}`;
      
      link.setAttribute('download', `receipts_export_${formattedTimestamp}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error("Export failed:", err);
      alert("An error occurred during export.");
    } finally {
      setExporting(false);
    }
  };

 useEffect(() => {
  if (isLoggedIn.role === 'admin') {
    loadData('');
    loadAllUsers();
  } else {
    loadData(`createdBy=${isLoggedIn._id}`);
  }
}, []);

  return (
    <>
      <Header />
      <div className='text-center'>
        <p className='login-heading mt-4'>
          <b>Bills</b>
        </p>
        <br />
        <p className=' mt-4'>
          <b>Total Bills : {bills.length}</b>
          <br />
          <b>Total Amount : {totalBillAmount}</b>
        </p>
      </div>
      <div className='container-fluid mt-5'>
        {initialLoading && (
          <div className='text-center'>
            <Loader />
          </div>
        )}

        {!initialLoading && (
          <>
            {isLoggedIn.role === 'admin' && (
              <div className='text-center d-flex j-center a-center'>
                <div>
                  <b>User :</b>
                  <select
                    className='mr-2'
                    name='createdBy'
                    value={filter.createdBy}
                    onChange={onChangeHandler}
                  >
                    <option value=''>Select User</option>
                    {users.map((user) => {
                      return (
                        <option key={user._id} value={user._id}>
                          {user.username}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div>
                  <b>State :</b>
                  <select
                    className='mr-2'
                    name='state'
                    value={filter.state}
                    onChange={onChangeHandler}
                  >
                    <option value=''>Select State</option>
                    {fields.allState.map((state) => {
                      return (
                        <option key={state.value} value={state.value}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div>
                  <b>From :</b>
                  <input
                    type='date'
                    name='from'
                    value={filter.from}
                    onChange={onChangeHandler}
                    className='mr-2'
                  />
                </div>
                <div>
                  <b>To :</b>
                  <input
                    type='date'
                    name='to'
                    value={filter.to}
                    onChange={onChangeHandler}
                    className='mr-2'
                  />
                </div>
                <button
                  className='btn-primary ml-2 mr-2'
                  onClick={onSearchHandler}
                >
                  Search
                </button>
                <button className='btn-danger' onClick={onResetHandler}>
                  Reset
                </button>
                <button
                  className='btn-success ml-2'
                  onClick={handleExport}
                  disabled={exporting}
                >
                  {exporting ? 'Exporting...' : 'Export to PDF'}
                </button>
              </div>
            )}

            {isLoggedIn.role !== 'admin' && (
              <div className='text-center d-flex j-center a-center'>
                <div>
                  <b>State :</b>
                  <select
                    className='mr-2'
                    name='state'
                    value={filter.state}
                    onChange={onChangeHandler}
                  >
                    <option value=''>Select State</option>
                    {memberStates.map((state) => {
                      return (
                        <option key={state.value} value={state.value}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div>
                  <b>From :</b>
                  <input
                    type='date'
                    name='from'
                    value={filter.from}
                    onChange={onChangeHandler}
                    className='mr-2'
                  />
                </div>
                <div>
                  <b>To :</b>
                  <input
                    type='date'
                    name='to'
                    value={filter.to}
                    onChange={onChangeHandler}
                    className='mr-2'
                  />
                </div>
                <button
                  className='btn-primary ml-2 mr-2'
                  onClick={onSearchHandler}
                >
                  Search
                </button>
                <button className='btn-danger' onClick={onResetHandler}>
                  Clear
                </button>
              </div>
            )}
            <br />
            <table className='table table-striped'>
              <thead className='thead-light'>
                <tr>
                  <th scope='col'>Receipt No</th>
                  <th scope='col'>Vehicle Category</th>
                  <th scope='col'>Regis No.</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>State</th>
                  <th scope='col'>Receipt State</th>
                  <th scope='col'>Tax Period</th>
                  <th scope='col'>Tax From Date</th>
                  <th scope='col'>Tax To Date</th>
                  <th scope='col'>Mobile No.</th>
                  <th scope='col'>User Charges</th>
                  <th scope='col'>Tax Amount</th>
                </tr>
              </thead>

              <tbody>
                {bills.length == 0 && (
                  <tr>
                    <td className='text-center' colSpan='12'>
                      <h3>No data</h3>
                    </td>
                  </tr>
                )}
                {bills.map((bill, i) => {
                  return (
                    <tr key={bill._id}>
                      <td>
                        <a
                          target='_blank'
                          href={`${BASE_URL.replace(/\/$/, "")}/bill/${bill._id}/pdf`}
                        >
                          {bill.receiptNo}
                        </a>
                      </td>
                      <td scope='row'>{bill.vehicleClass}</td>
                      <td>{bill.vehicleNo}</td>
                      <td>{bill.ownerName}</td>
                      <td>{bill.fromState}</td>
                      <td>{bill.state}</td>
                      <td scope='row'>{bill.taxMode}</td>
                      <td>{formatDate(bill.taxFromDate, false)}</td>
                      <td>{formatDate(bill.taxUptoDate, false)}</td>
                      <td scope='row'>{bill.mobileNo}</td>
                      <td scope='row'>-</td>
                      <td scope='row'>{bill.totalAmount}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
        <br />
        <br />
      </div>
    </>
  );
};

export default Bills;
